import React from 'react'
import Select from "react-select";

const WSelect = ({ options, value, setValue, defaultValue = '', placeholder = '', multi= false, searchable = false }) => {
  return (
    <Select
      options={options.map((o) => {
        return { label: o, value: o }
      })}
      placeholder={placeholder}
      className="single-select"
      classNamePrefix="react-select"
      value={
        { label: value || defaultValue, value: value || defaultValue }
      }
      onChange={(e) => setValue(e.value)}
      isMulti={multi}
      isSearchable={searchable}
    />
  )
}

export default WSelect
